import React, { Component } from "react";
import AddExamConfig from "../AddExamConfig/AddExamConfig";

class EditExamConfig extends Component {
  render() {
    return (
      <AddExamConfig
        editStatus={true}
        examConfigId={this.props.match.params.id}
      />
    );
  }
}

export default EditExamConfig;
